<template>
    <div id="classadd">
        <headers title="添加学生"></headers>
        <div class="tips">请输入你学生的手机号加入班级</div>
        <div class="input">
            <input type="number" v-model.trim="phone" max-length="11" @input="onInput" placeholder="请输入学生手机号">
        </div>
        <div class="btn" :class="phone.length?'active':''" @click="search">确定</div>
    </div>
</template>
<script type="text/ecmascript-6">
import headers from "COMPONENTS/base/header.vue";
export default {
    components: {
        headers,
    },
    data () {
        return {
            unit_class_id:this.$route.params.unit_class_id,
            phone:'',
        }
    },

    methods: {
        onInput ( ) {
            this.phone = this.phone.slice(0, 11)
        },
        search(){
            if(!this.phone.length){
                return
            }
            var pattern = /^(13[0-9]|15[0-35-9]|16[0-9]|17[0-9]|18[0-9]|19[0-35-9])\d{8}$/; //11位手机号码正则;
            var boolphone = pattern.test(this.phone);
            if (!boolphone) {
                layer.tips('手机号码不正确')
                return
            }
            this.$store.commit('setSearchPhone',this.phone)
            this.$router.push('/classlist/result/'+this.unit_class_id)
        }
    },
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.flex {
    display: flex;
}

.jb {
    justify-content: space-between;
}

.ac {
    align-items: center;
}

#classlist {
    padding-top: $h-header;
}
.tips {
    text-align: center;
    padding: 40px/$ppr 0 20px/$ppr;
    color: #5e89ef;
}
.input{
    margin: 32px/$ppr;
    border:1px/$ppr solid #5e89ef;
    border-radius: 10px/$ppr;
    overflow: hidden;
    input{
        width: 100%;
        background:#fff;
        border:none;
        text-align: center;
        font-size: 28px/$ppr;
        padding: 20px/$ppr 0;
    }
}
.btn{
    margin: 64px/$ppr 32px/$ppr 32px/$ppr 32px/$ppr;
    color: #999;
    background:#eaeaea;
    line-height: 72px/$ppr;
    border-radius: 72px/$ppr;
    text-align: center;
    &.active{
         color: #fff;
    background:#5e89ef;
    }
}


</style>